<template>
  <el-dialog
    class="threeD-popup"
    :class="device.isMobile ? 'threeD-popup-mobile' : ''"
    :title="dialogTitle"
    :visible.sync="visible"
    :destroy-on-close="true"
    :append-to-body="true"
    @close="closeHandle"
    style="z-index: 10000"
    v-if="visible"
  >
    <div class="content-box">
      <div class="threeD-content-box" :class="screenType === 'width' ? 'threeD-content-box-width' : screenType === 'height' ? 'threeD-content-box-height' : ''" id="iframeBox">
        <div class="threeD-box">
          <iframe id="iframe" class="threeD" :src="threeDList[activeIndex].url" marginwidth="0" frameborder="0" :scrolling="iframeScrolling" height="100%"></iframe>
        </div>
      </div>
      <div class="list-box">
        <div
          v-for="(item, index) in threeDList"
          :key="item.key"
          class="threeD-item"
          :class="activeIndex == index ? 'threeD-item-active' : ''"
          @click="changeThreeD(index)"
        >
          <div class="item-cover">
            <el-image class="cover-image" :src="item.cover" fit="cover"></el-image>
          </div>
          <div class="item-title">{{ item.title }}</div>
        </div>
      </div>
      <!-- <div class="action-btn">
        <el-button class="btn" size="mini" type="primary" @click="openInNewPage" v-if="showInNewPage">在新页面打开</el-button>
        <el-button class="btn" size="mini" type="primary" @click="openInFullPage" v-if="showInFullPage">全屏查看</el-button>
      </div>
      <div class="close-btn" @click="closeHandle">
        <span class="el-icon-circle-close"></span>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
/*
三维模型集合弹窗
*/
export default {
  name: "threeDPopup",
  props: {
    dialogTitle: {
      type: String,
      default: ""
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    threeDList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    showInNewPage: {
      type: Boolean,
      default: false
    },
    showInFullPage: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    dialogVisible(newVal) {
      this.visible = newVal
      // if(this.visible) {
      //   this.setIframeHeight(document.getElementById('iframe'))
      // }
      if(newVal) {
        this.$nextTick(() => {
          this.loadIframe();
        })
      }
    }
  },
  data() {
    return {
      visible: false,
      activeIndex: 0,
      iframeScrolling: 'no',
      screenType: '',
    }
  },
  methods: {
    loadIframe() {
      // 超长或者超宽的手机屏幕，进行放大的适配
      setTimeout(() => {
        let iframeBox = document.getElementById('iframeBox');
        if(iframeBox) {
          let width = iframeBox.clientWidth;
          let height = iframeBox.clientHeight;

          console.log(width, height)

          if(this.device.isMobile && !this.device.isIos && (height / width < 1.1)) {
            this.screenType = 'width'
          }else if(this.device.isMobile && !this.device.isIos && (height / width > 2.2)){
            this.screenType = 'height'
          }
        }else{
          this.loadIframe()
        }
      }, 100)
    },
    changeThreeD(index) {
      this.activeIndex = index
    },
    // 同源网页可以用此方法设置属性
    setIframeHeight(iframe) {
      if (iframe) {
        let iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
        if (iframeWin.document.body) {
          //这边加五十是高度，如果想要再高一点的页面可以将数字变大，可以自己调
          iframe.height = iframeWin.document.body.scrollHeight+50;
        }
      }
    },
    closeHandle() {
      this.$emit('dialogClose')
    },
    openInNewPage() {
      window.open(this.threeDList[this.activeIndex].url)
    },
    openInFullPage() {
      //设置后就是id==inner 的容器全屏
      var fullPage = document.getElementById('iframe')
      if (this.fullscreen) {
        if (document.exitFullscreen) {
            document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
        }
        this.iframeScrolling = 'no'
      } else {
        if (fullPage.requestFullscreen) {
          fullPage.requestFullscreen()
        } else if (fullPage.webkitRequestFullScreen) {
          fullPage.webkitRequestFullScreen()
        } else if (fullPage.mozRequestFullScreen) {
          fullPage.mozRequestFullScreen()
        } else if (fullPage.msRequestFullscreen) {
          // IE11
          fullPage.msRequestFullscreen()
        }
        this.iframeScrolling = 'auto'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.threeD-popup{
  text-indent: 0;

  /deep/.el-dialog{
    height: 85%;
  }

  .content-box{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .threeD-content-box{
      width: 100%;
      flex: 1;
      background: #fff;
      overflow: hidden;

      .threeD-box{
        width: 100%;
        height: 100%;
        transform-origin: top center;
        transform: scale(0.5);
        position: relative;
  
        .threeD{
          width: 100%;
          padding: 0;
          width: 200%;
          height: 200%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    
    .threeD-content-box-width{
      .threeD-box{
        .threeD{
          width: 100%;
        }
      }
    }
    .threeD-content-box-height{
      .threeD-box{
        .threeD{
          height: 160%;
        }
      }
    }

    .list-box{
      padding: 34rem 15rem 24rem;
      overflow: hidden;
      // overflow-x: scroll;
      white-space: nowrap;
      border-top: 1px solid #e3e3e3;

      .threeD-item{
        width: 120rem;
        display: inline-block;
        margin-right: 10rem;
        box-sizing: border-box;

        .item-cover{
          width: 120rem;
          height: 150rem;
          display: flex;
          align-items: center;
          overflow: hidden;

          .cover-image{
            width: 120rem;
            height: 120rem;
            border: 1px solid #e3e3e3;
          }
        }

        .item-title{
          width: 120rem;
          padding: 10rem;
          font-size: 16rem;
          line-height: 24rem;
          color: #333;
          opacity: 0.65;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .threeD-item-active{
        width: 150rem;
        
        .item-cover{
          width: 150rem;
          height: 150rem;
          border: 5rem solid #0FC29A;
          box-sizing: border-box;

          .cover-image{
            width: 140rem;
            height: 140rem;
          }
        }
        
        .item-title{
          width: 150rem;
        }
      }
    }

    .action-btn{
      position: absolute;
      bottom: 50rem;
      right: 10rem;
      width: 150rem;
      

      .btn{
        margin: 0 auto;
        margin-bottom: 30rem;
      }
    }
  }
}
.threeD-popup-mobile{
  .content-box{
    .threeD-content-box{

      .threeD-box{
        .threeD{
          // width: 200%;
        }
      }
    }
    .list-box{
      .threeD-item{
        .item-title{
          font-size: 20rem;
        }
      }
    }
    
    .action-btn{
      bottom: 30rem;
      width: 200rem;
    }
  }
}
</style>